import { observer } from "mobx-react-lite";
import { NavItem } from "@menu/core/types";
import MenuContext from "@menu/core/menu.context";
import { AnalyticsType, getAnalyticTags, getDataTitleTag } from "@menu/core/lib";
import getNavItemsWithState, { NavItemAndState } from "@menu/core/lib/get-navitems-with-state";

type HeaderLinksProps = {
    onSelect: (e: any, link: NavItem) => void,
    context: MenuContext
}

const HeaderLinks = observer((props: HeaderLinksProps) => {
    const { onSelect, context } = props;

    const links = getNavItemsWithState(context);

    if (!links) {
        return null;
    }

    const getCssClassAttribute = (item: NavItemAndState) => {
        const names = [];
        const {isActive, isOnPath} = item.state;

        if (isActive) {
            names.push("active");
        }

        if (isOnPath) {
            names.push("on-path");
        }

        if (!names.length) {
            return {};
        }

        return {
            "className": names.join(" ")
        };
    }

    const getAnalytics = (item: NavItem) => {
        return getAnalyticTags({
            component_name: "header_top_nav",
            nav_item: AnalyticsType.topLevel,
            nav_text: item.title,
            target_page_url: context.siteUrl
        });
    }

    const cssClassName = "site-links" + (context.selectedArea ? " active" : "");

    return (<ul className={cssClassName}>
        {links.map((x, ix) =>
            <li key={ix}
                {...getDataTitleTag(x.item.title)}
                {...getCssClassAttribute(x)}
                {...getAnalytics(x.item)}
                onClick={(e) => onSelect(e, x.item)}>
                {x.item.title}
            </li>)}
    </ul>);
});

export default HeaderLinks;